module.exports = __webpack_public_path__ + "static/media/heart_icon.923540b3.svg";